import React, { useEffect, useState } from "react";
import { jobStatusHistory } from "../../../api/jobApi";
import { formatFromJsonDate } from "../../../dateConfig";
import LoadingSpinner from "../../LoadingSpinner";
import { CiPlay1 } from "react-icons/ci";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
} from "@mui/lab";

const MoreInfoStatus = ({ requestId, jobId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [statusData, setStatusData] = useState([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const statusData = await jobStatusHistory({ requestId, jobId });
      if (statusData) {
        setStatusData(
          statusData.map((sta) => ({
            ...sta,
            rstDate: sta.rstDate ? formatFromJsonDate(sta.rstDate) : "",
          })),
        );
      }

      setIsLoading(false);
    })();
  }, [jobId, requestId]);

  return (
    <div className="ui segment">
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <CiPlay1 />
            <h3 style={{ margin: 0 }}>Status</h3>
          </div>
          <div className="ui divider"></div>
          <div style={{ padding: "10px 40px" }}>
            <Timeline
              sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                  flex: 0,
                  padding: 0,
                },
              }}
              style={{
                margin: "0px",
                overflowY: "auto",
                overflowX: "hidden",
                padding: "0px",
              }}
            >
              {statusData &&
                statusData.map((status, index) => (
                  <TimelineItem key={index}>
                    <TimelineSeparator>
                      <TimelineDot color={index === 0 ? "primary" : "grey"} />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <div className="timeline-container">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <h4
                            style={{
                              color: index === 0 ? "primary" : "grey",
                            }}
                          >
                            {status.rstDescription}
                          </h4>
                          <h5>{status.staRefCode}</h5>
                        </div>
                        <p>{status.rstUser}</p>
                        <p>{status.rstDate}</p>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                ))}
            </Timeline>
          </div>
        </>
      )}
    </div>
  );
};

export default MoreInfoStatus;
